import { Drawer, Menu } from 'antd';
import type { MenuProps } from 'antd';
import { LAYOUT_CONSTANTS } from '../../hooks/useResponsive';
import { FONT_FAMILY_BASE } from '../../constants/fonts';

interface MobileDrawerMenuProps {
  /** ドロワーの表示状態 */
  open: boolean;
  /** ドロワーを閉じるコールバック */
  onClose: () => void;
  /** メニューアイテム */
  menuItems: MenuProps['items'];
  /** 選択中のキー */
  selectedKeys?: string[];
  /** 開いているサブメニューのキー */
  openKeys?: string[];
  /** サブメニュー開閉時のコールバック */
  onOpenChange?: (keys: string[]) => void;
  /** メニュークリック時のコールバック */
  onMenuClick?: (key: string) => void;
  /** タイトル */
  title?: string;
  /** サブタイトル */
  subtitle?: string;
  /** メニュー背景色 */
  menuBackgroundColor?: string;
  /** ヘッダー背景（グラデーションなど） */
  headerBackground?: string;
}

/**
 * モバイル用ドロワーメニューコンポーネント
 *
 * 768px未満の画面でサイドバーの代わりに使用するドロワーメニュー
 */
export function MobileDrawerMenu({
  open,
  onClose,
  menuItems,
  selectedKeys,
  openKeys,
  onOpenChange,
  onMenuClick,
  title = '一元帳',
  subtitle = 'ICHIGEN-CHO',
  menuBackgroundColor = '#001529',
  headerBackground = 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
}: MobileDrawerMenuProps) {
  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    onMenuClick?.(key);
    // メニュークリック後にドロワーを閉じる
    onClose();
  };

  return (
    <Drawer
      placement="left"
      open={open}
      onClose={onClose}
      width={LAYOUT_CONSTANTS.MOBILE_DRAWER_WIDTH}
      styles={{
        body: { padding: 0 },
        header: { display: 'none' },
      }}
      // ドロワーの背景色
      style={{ background: menuBackgroundColor }}
    >
      <div className="mobile-drawer-menu">
        {/* ヘッダー部分 */}
        <div
          style={{
            height: 64,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            background: headerBackground,
            flexShrink: 0,
            padding: '12px 16px',
          }}
        >
          <span
            style={{
              color: '#fff',
              fontWeight: 700,
              fontSize: 22,
              letterSpacing: '0.05em',
              fontFamily: FONT_FAMILY_BASE,
            }}
          >
            {title}
          </span>
          <span
            style={{
              color: '#fff',
              fontSize: 10,
              letterSpacing: '-0.0em',
              fontFamily: FONT_FAMILY_BASE,
            }}
          >
            {subtitle}
          </span>
        </div>

        {/* メニュー部分 */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            background: menuBackgroundColor,
          }}
        >
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            onOpenChange={(keys) => onOpenChange?.(keys as string[])}
            items={menuItems}
            onClick={handleMenuClick}
            style={{
              borderRight: 0,
              paddingTop: 8,
            }}
          />
        </div>
      </div>
    </Drawer>
  );
}
